var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('toggle-button',{attrs:{"value":_vm.booleanValue,"sync":true,"labels":{checked:_vm.$t(_vm.checkLabel),unchecked:_vm.$t(_vm.uncheckLabel)},"disabled":_vm.disabled,"color":"#009688"},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }